import {objectType} from "_src/constants";
import Wrapper from "_src/wrapper";
import loader from "_src/loader";
import containersCache from "_src/engine/packers/containers_cache";
import reformer from "_src/reformer/reformer";

class KnotWrapper {
  constructor(dataGetter, isPerpendicular = false, parentUUID = null) {
    this._dataGetter = dataGetter;
    this.isPerpendicular = isPerpendicular;
    this.parentUUID = parentUUID;
  }

  getData() {
    return this._dataGetter();
  }
}

export default class DistanceMeasureWrapper extends Wrapper {
  constructor(params) {
    super(params);
    this.type = params.type !== undefined ? params.type : objectType.LINEAR_MEASURE;
    this.knots = [];
  }

  getHash() {
    return this._selfPropertyGetter("geometriesSource")["hash"];
  }

  getSelection() {
    return this._selfPropertyGetter("selected");
  }

  setSelection(selected) {
    this._selfPropertySetter("selected", selected);
  }

  async _loadData() {
    const geometryProperties = this._selfPropertyGetter("geometries");
    if (this.type === objectType.LINEAR_MEASURE) {
      for (let i=0; i<geometryProperties.length; i++) {
        const knotWrapper = new KnotWrapper(() => geometryProperties[i]["position"], geometryProperties[i]["perpendicular"], geometryProperties[i]["object-uuid"]);
        this.knots.push(knotWrapper);
      }
    } else {
      const loadingFiles = new Set();
      const loadingPromises = [];
      for (const knotProperty of geometryProperties) {
        const file = knotProperty["file"];
        const index = knotProperty["index"];
        const payload = {
          objectID: this.getID(),
          frameID: -1,
          id: index,
        };
        loadingFiles.add(file);
        const promise = loader.load(reformer.getProjectDirectory() + file, loader.GEOMETRY, payload).then(geometry => {
          const points = geometry.getItemBuffer("a_position");
          const knotWrapper = new KnotWrapper(() => points);
          this.knots.push(knotWrapper);
        });
        loadingPromises.push(promise);
      }
      await Promise.all(loadingPromises);

      for (const file of loadingFiles) {
        containersCache.releaseContainer(file);
      }
    }
  }

  _unloadData() {
    this.knots.length = 0;
  }
}
